import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/calls/call-queue-stats')({
  staticData: { team: 'fe-phone-experience' },
});
